import { useEffect, useState } from 'react';
import { fetchBrand, type Brand } from '../api';

export type { Brand };

export interface UseBrandResult {
  brand: Brand | null;
  loading: boolean;
  error: string | null;
}

export function useBrand(): UseBrandResult {
  const [brand, setBrand] = useState<Brand | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchBrand()
      .then((b) => {
        if (cancelled) return;
        setBrand(b);
        const root = document.documentElement.style;
        root.setProperty('--brand-color', b.primaryColor || '#1f2937');
        root.setProperty(
          '--brand-color-secondary',
          b.secondaryColor || b.primaryColor || '#1f2937',
        );
        if (b.brandName) {
          document.title = `${b.brandName} — Tax Exempt Form`;
        }
      })
      .catch((err: Error) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { brand, loading, error };
}
